import prop from 'lodash/fp/prop';
import eq from 'lodash/fp/eq';

let cfg;

const defaults = () => ({
  rootElement: () => (eq('undefined')(typeof document) ? null : prop('body')(document)),
});

export const config = (configuration) => {
  cfg = {
    ...defaults(),
    ...configuration,
  };
};

export const restore = () => {
  cfg = {
    ...defaults(),
  };
};

export const getRootElement = () => cfg.rootElement();

restore();
